import Loadable from 'react-loadable'

const Story = Loadable({
    loader: () => import(/* webpackChunkName: "desktopStory" */ './story'),
    loading: () => null,
})

const StoryRoute = ({
    match: {
        params: { slug },
    },
}) => <Story slug={slug} />

export default StoryRoute
